import React from 'react';
import { Provider } from 'react-redux';
import JssProvider from 'react-jss/lib/JssProvider';
import ReactDOM from 'react-dom';
import { orange, red, grey, indigo } from '@material-ui/core/colors';
import { MuiThemeProvider, createMuiTheme, createGenerateClassName } from '@material-ui/core/styles';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers';

import LoaderExternalInterface from './services/LoaderExternalInterface';
import App from './components/App';
// import registerServiceWorker from './registerServiceWorker';

const generateClassName = createGenerateClassName({
	productionPrefix: 'aareadparagraph'
});

const theme = createMuiTheme({
	typography: {
		fontFamily: 'Open Sans'
	},
	palette: {
		primary: indigo,
		secondary: orange,
		error: red,
	},
	overrides: {
		MuiButton: {
			label: {
				fontWeight: 600
			},
			sizeLarge: {
				fontSize: '1.1rem'
			}
		},
		MuiTypography: {
			subheading: {
				fontSize: '1.1rem'
			},
			headline: {
				color: grey[800],
			},
			title: {
				color: grey[700]
			},
			display1: {
				fontSize: '1.8rem'
			}
		}
	}
});

window.loader.exercises.aareadparagraph = {};

window.loader.exercises.aareadparagraph.render = (el, base, testMode, onDataLoaded) => {
	const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ // eslint-disable-line no-underscore-dangle
		name: `aaReadParagraph: ${base}`,
		defaultPanel: 'state'
	}) : compose;
	const store = createStore(
		reducers,
		{},
		composeEnhancers(applyMiddleware(thunk))
	);

	const loaderExternalInterface = new LoaderExternalInterface(store, base);

	ReactDOM.render(
		<Provider store={store}>
			<JssProvider generateClassName={generateClassName}>
				<MuiThemeProvider theme={theme}>
					<App
						loaderAppElement={el}
						loaderExternalInterface={loaderExternalInterface}
						base={base}
						testMode={testMode}
						onDataLoaded={onDataLoaded}
						store={store}
					/>
				</MuiThemeProvider>
			</JssProvider>
		</Provider>
		, el);

	return loaderExternalInterface;
};

// registerServiceWorker();
